"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePrimaryAddressQuery = void 0;
var _fetching = require("@ori/fetching");
var _swrConfig = require("../constants/swrConfig");
var _useUrlOptions = require("../hooks/useUrlOptions");
var _logger = require("../logger");
var _utils = require("../utils");
const fetchData = async (options)=>{
    const promise = (0, _utils.getUrl)(options);
    promise.catch((error)=>{
        _logger.mainLogger.error(error, {
            action: 'usePrimaryAddressQuery'
        });
    });
    return promise;
};
const usePrimaryAddressQuery = (isActive)=>{
    if (isActive) {
        (0, _logger.logDebug)('usePrimaryAddressQuery() hook called.');
    }
    const { cacheKeys, urlOptions } = (0, _useUrlOptions.useUrlOptions)('/system/ajax/DeliverySelection/GetPrimaryAddress');
    const fetcher = async ()=>fetchData(urlOptions);
    const { data, error, isValidating } = (0, _fetching.useSWR)(isActive ? cacheKeys : null, fetcher, _swrConfig.errorHandlingSwrOptions);
    return {
        primaryAddress: data,
        error,
        isPrimaryAddressLoading: isValidating
    };
};
exports.usePrimaryAddressQuery = usePrimaryAddressQuery;
